/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Upoznaj nove ljude, čavrljaj, druži se",
      "Netočan telefonski broj",
      "Get the app",
      "Nastavi koristeći Apple",
      "Nastavi koristeći Facebook",
      "Nastavi koristeći Google",
      "Prijavi se",
      "Registriraj se",
      "Za nastavak, unesi znakove koje vidiš u polje za unos.",
      "Nastavi",
      "Unesi znakove",
      "Sigurnosna provjera",
      "Ponovo učitaj",
      "Odaberi novu lozinku koju ćeš lako zapamtiti:",
      "Potvrdi",
      "Potvrdi lozinku",
      "Lozinka mora sadržavati najmanje {{num}} [[characters:num@3]]",
      "Lozinka",
      "Postavi novu lozinku",
      "Badoo - Blog",
      "Zaposlenje",
      "Čavrljanje",
      "Gradovi",
      "Upravljaj kolačićima",
      "Copyright © 2006 – danas. Bumble. Sva prava pridržana.",
      "Apple i Apple logotip su zaštitni znakovi tvrtke Apple Inc.{{__EOL__}}Google Play je zaštitni znak tvrtke Google LLC.",
      "Preuzmi",
      "Facebook",
      "Prati nas",
      "Centar za pomoć",
      "Instagram",
      "Jezik",
      "LinkedIn",
      "Pregled",
      "Badoo je dio Bumble Inc.",
      "Izjava o privatnosti",
      "Safety Centre",
      "Sitemap",
      "Izjava o suvremenom ropstvu",
      "Uvjeti korištenja",
      "Twitter",
      "Unesi svoj e-mail ili broj mobitela i poslat ćemo ti upute za postavljanje nove lozinke.",
      "Zatraži novu lozinku",
      "Unesi svoj e-mail ili broj mobitela",
      "Zaboravljena lozinka",
      "Prikazani modeli služe samo u svrhu ilustracije.",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Ne moraš čekati da se svidite jedno drugome.{{__EOL__}}{{__EOL__}}Možete odmah započeti konkretnije razgovore i brže stići do onoga što oboje želite. Znaš na što mislimo, ono kad se stvarno počnete upoznavati.",
      "Želiš odmah čavrljati?",
      "Nastaviš li s registracijom, ujedno prihvaćaš naše <a class=\"link\" href=\"{{terms_url}}\">Uvjete korištenja</a>. Saznaj više o tome kako koristimo tvoje podatke u našoj <a class=\"link\" href=\"{{privacy_url}}\">Izjavi o privatnosti</a>.",
      "S nama je upoznavanje spontano, prirodno i ugodno <br />jer ti pomažemo da budeš ono što jesi.",
      "Za upoznavanje sa samopouzdanjem",
      "Ili",
      "Već imaš korisnički račun?",
      "Registriraj se e-mailom ili mobitelom",
      "Pronađi točno ono što tražiš.{{__EOL__}}Nema potrebe za opravdanjima.",
      "Samo želiš čavrljati. To je OK.{{__EOL__}}Tražiš nešto trajnije? Fantastično.{{__EOL__}}{{__EOL__}}Ako se ikad poželiš predomisliti, samo naprijed.",
      "Želim upoznavanje",
      "Traže ozbiljnu vezu",
      "Hoće čavrljati",
      "Upoznaj ljude koji žele isto što i ti.",
      "{{name}}, {{age}}",
      "Tvoja sigurnost naš je prioritet",
      "Naš Safety Centre na jednom mjestu objedinjuje sve podatke i podršku koji su ti potrebni za samouvjereno upoznavanje.",
      "Posjeti naš Safety Centre",
      "Sigurnost na<br/>prvom mjestu, uvijek.",
      "Od prvog trenutka smo znali da smo jedno za drugo...",
      "Isprva, nije me zanimalo ništa ozbiljno…",
      "Svima na Badoo aplikaciji savjetujem samo da budu ono što jesu...",
      "Badoo Priče o uspjehu",
      "Pogledaj više priča o uspjehu",
      "{{num}}__CUT__Ocjena",
      "Apple App Store",
      "Vjeruj nam, spojili smo milijune (i milijune i milijune) parova još od 2006. godine.",
      "{{num}}+ mil.__CUT__preuzimanja",
      "{{num}}+ mil.",
      "Google Play Store",
      "Znamo što radimo.",
      "Prijavi se koristeći e-mail ili broj mobitela",
      "Unesi svoju lozinku",
      "Zaboravljena lozinka?",
      "Registriraj se",
      "Nemaš korisnički račun?",
      "Prijava",
      "Registriraj se"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "znakova",
                  "znakova",
                  "znakovima",
                  "znakova",
                  "znakova",
                  "znakova",
                  "znaka"
            ],
            "plural": [
                  "znakova",
                  "znakova",
                  "znakovima",
                  "znakova",
                  "znakova",
                  "znakova",
                  "znaka"
            ],
            "singular": [
                  "znak",
                  "znaka",
                  "znaku",
                  "znak",
                  "znaku",
                  "znakom",
                  "znak"
            ]
      },
      "day": {
            "few": [
                  "dana",
                  "dana",
                  "danima",
                  "dana",
                  "danima",
                  "danima",
                  "dana"
            ],
            "plural": [
                  "dana",
                  "dana",
                  "danima",
                  "dana",
                  "danima",
                  "danima",
                  "dana"
            ],
            "singular": [
                  "dan",
                  "dana",
                  "danu",
                  "dan",
                  "danu",
                  "danom",
                  "dan"
            ]
      },
      "hour": {
            "few": [
                  "sata",
                  "sata",
                  "satima",
                  "sata",
                  "satima",
                  "satima",
                  "sata"
            ],
            "plural": [
                  "sati",
                  "sati",
                  "satima",
                  "sati",
                  "satima",
                  "satima",
                  "sati"
            ],
            "singular": [
                  "sat",
                  "sata",
                  "satu",
                  "sat",
                  "satu",
                  "satom",
                  "sat"
            ]
      },
      "minute": {
            "few": [
                  "minute",
                  "minuta",
                  "minutama",
                  "minute",
                  "minutama",
                  "minutama",
                  "minute"
            ],
            "plural": [
                  "minuta",
                  "minuta",
                  "minutama",
                  "minuta",
                  "minutama",
                  "minutama",
                  "minuta"
            ],
            "singular": [
                  "minuta",
                  "minute",
                  "minuti",
                  "minutu",
                  "minuti",
                  "minutom",
                  "minuto"
            ]
      },
      "month": {
            "few": [
                  "mjeseca",
                  "mjeseca",
                  "mjesecima",
                  "mjeseca",
                  "mjesecima",
                  "mjesecima",
                  "mjeseci"
            ],
            "plural": [
                  "mjeseci",
                  "mjeseci",
                  "mjesecima",
                  "mjeseci",
                  "mjesecima",
                  "mjesecima",
                  "mjeseci"
            ],
            "singular": [
                  "mjesec",
                  "mjeseca",
                  "mjesecu",
                  "mjesec",
                  "mjesecu",
                  "mjesecom",
                  "mjeseče"
            ]
      },
      "second": {
            "few": [
                  "sekunde",
                  "sekunde",
                  "sekundama",
                  "sekunde",
                  "sekundama",
                  "sekundama",
                  "sekunde"
            ],
            "plural": [
                  "sekundi",
                  "sekundi",
                  "sekundama",
                  "sekunde",
                  "sekundama",
                  "sekundama",
                  "sekunde"
            ],
            "singular": [
                  "sekunda",
                  "sekunde",
                  "sekundi",
                  "sekundu",
                  "sekundi",
                  "sekundom",
                  "sekundo"
            ]
      },
      "year": {
            "few": [
                  "godine",
                  "godina",
                  "godinama",
                  "godine",
                  "godinama",
                  "godinama",
                  "godine"
            ],
            "plural": [
                  "godina",
                  "godina",
                  "godinama",
                  "godina",
                  "godinama",
                  "godinama",
                  "godina"
            ],
            "singular": [
                  "godina",
                  "godine",
                  "godini",
                  "godinu",
                  "godini",
                  "godinom",
                  "godino"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
